// extracted by mini-css-extract-plugin
module.exports = {"body":"Interest_body__3iv8Z","container":"Interest_container__29cVv","card":"Interest_card__3rrUr","imgbox":"Interest_imgbox__34KMU","content":"Interest_content__u_hpJ"};